import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistancenumber-card',
  templateUrl: './helpbutton-reports-assistancenumber-card.component.html',
  styleUrls: ['./helpbutton-reports-assistancenumber-card.component.scss']
})
export class HelpbuttonReportsAssistancenumberCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
